import { useMemo } from 'react';
import { Capability } from 'homey-lib/webpack/index.js';

import { zoneActivityCapabilities } from '../../config/zoneActivityCapabilities';
import { DeviceSettings } from '../../config/DeviceSettings';

import { theme } from '../../theme/theme';

import { Icon } from '../common/Icon';
import { ZoneActivityPulse } from '../zone/ZoneActivityPulse';

import { iconWarningCircle } from '../../theme/icons/interface/warning-circle/warning-circle';

export function IndicatorAlarmStatic({ device }) {
  const hasOnlyZoneActivityAlarm = useMemo(() => {
    // If we have a zone activity capability and the zone activity is not disabled,
    // we set the component to 'zoneActivity'. We won't get here if there is already
    // an alarm capability also we continue the loop to search for an alarm capability
    let hasOnlyZoneActivityAlarm = false;

    for (const [valueKey] of Object.entries(device.capabilitiesObj ?? {})) {
      if (zoneActivityCapabilities.has(valueKey)) {
        hasOnlyZoneActivityAlarm = true;
        continue;
      }

      if (Capability.getBaseId(valueKey).startsWith('alarm_')) {
        hasOnlyZoneActivityAlarm = false;
        break;
      }
    }

    return hasOnlyZoneActivityAlarm;
  }, [device.capabilitiesObj]);

  if (!device.settings[DeviceSettings.ZoneActivityDisabled] && hasOnlyZoneActivityAlarm) {
    return <ZoneActivityPulse />;
  }

  return <Icon display="block" url={iconWarningCircle} color={theme.color.yellow} size="20px" />;
}
